export const Service = {
  async recoverPassword(payload: { email: string }) {
    const response = await fetch('/api/auth2/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return response.json();
  },
};
